// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { BoletoBarcode } from './boleto-barcode';
import { BoletoTicket } from './boleto-ticket';
import { BoletoSavePDFButton } from './boleto-save-pdf-button';
import { BoletoTips } from './boleto-tip-box';

export function BoletoPendingPage(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <p>Use as informações abaixo para pagar seu boleto:</p>

      <BoletoTicket allFeatures={allFeatures} />

      <BoletoBarcode />

      <IfFeature allFeatures={allFeatures} wanted="display_boleto_tips">
        <BoletoTips />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_boleto_save_pdf">
        <BoletoSavePDFButton />
      </IfFeature>
    </>
  );
}
